import { render, staticRenderFns } from "./tipsDelayDialog.vue?vue&type=template&id=4c4d2fc6&scoped=true"
import script from "./tipsDelayDialog.vue?vue&type=script&lang=js"
export * from "./tipsDelayDialog.vue?vue&type=script&lang=js"
import style0 from "./tipsDelayDialog.vue?vue&type=style&index=0&id=4c4d2fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d2fc6",
  null
  
)

export default component.exports